import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { AuthenticateGuard } from './guards/authenticate/authenticate.guard';

export const unAuthenticatedRoute = {
  canActivate: [AuthenticateGuard],
  data: { routeToRedirect: environment.config.redirectToWhenAuthenticated, unprotectedRoute: true },
};

export const authenticatedRoute = {
  canActivate: [AuthenticateGuard],
  data: { routeToRedirect: environment.config.redirectToWhenUnauthenticated, protectedRoute: true },
};

export const routes: Routes = [
  { path: '', redirectTo: 'pages/users', pathMatch: 'full' },
  { path: 'pages', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), ...authenticatedRoute },
  { path: 'auth', loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule), ...unAuthenticatedRoute },
  { path: 'first-access', loadChildren: () => import('./pages/first-access/first-access.module').then(m => m.FirstAccessModule), ...authenticatedRoute},
  { path: '**', redirectTo: 'pages/users' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always', relativeLinkResolution: 'corrected' })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
